import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { EulaPopupComponent } from './core/shared/components/eula-popup/eula-popup.component';
import { GlobalService } from './core/shared/services/global.service';
import { Documents } from 'src/environments/constants';
import { environment } from 'src/environments/environment';

import { Environment as EnvironmentEnum, SetEnvironment, UserState, NavigationItem, SidepanelTypes, AboutPanelComponent, AboutPanelInputs, SidePanel } from '@gea/digital-ui-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('header', { read: ElementRef }) header?: ElementRef;

  public title: string = 'InsightPartner Filtration';

  public contentReady: boolean = false;
  public noAuth: boolean = false;
  public sideBarOpen: string = '';

  public environment = environment;
  public data: NavigationItem[] = [];
  private observer?: MutationObserver;
  botItems: SidePanel[] = [];

  constructor(
    private translate: TranslateService,
    private store: Store,
    private route: Router,
    private globalService: GlobalService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.navigate();

    this.store.dispatch(new SetEnvironment(environment.name || EnvironmentEnum.PROD));
    this.store.select(UserState.token).subscribe(token => { if (token) this.loadCookies() });

    this.translate.setDefaultLang('en-US');
    const selectedLanguage = localStorage.getItem('language');

    if (selectedLanguage && selectedLanguage.length > 2) {
      this.translate.use(selectedLanguage);
    } else {
      localStorage.setItem('language', 'en-US');
      this.translate.use('en-US');
    }
  }

  ngAfterViewInit(): void {
    this.resize();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private resize(): void {
    this.observer = new MutationObserver(m => {
      if (window.innerWidth < 1442) {
        this.sideBarOpen = '2%'
        return;
      }
      const nav = this.header?.nativeElement.querySelector('.nav-bar.full');
      this.sideBarOpen = nav ? 'calc(2% + 270px)' : '5%';
    })

    const domSideBar = this.header?.nativeElement;
    this.observer.observe(domSideBar, { childList: true, subtree: true });
  }

  public openDataprivacy(): void {
    window.open(Documents.DataPrivay);
  }

  public openTermsAndConditions(): void {
    window.open(Documents.TermsOfUse);
  }

  public openImprint(): void {
    window.open(Documents.Imprint);
  }

  public openEula(): void {
    window.open(Documents.Eula);
  }

  public openEulaPopUp(): void {
    this.dialog.open(EulaPopupComponent, { width: '50rem', disableClose: true });
  }

  private loadCookies(): void {
    this.globalService.getUserMemberships().subscribe({
      next: () => {
        if (this.contentReady) return;
        this.globalService.hasEula().subscribe(eula => eula ? this.contentReady = true : this.openEulaPopUp())
      },
      error: () => this.globalService.logout()
    });
  }

  private navigate(): void {
    this.route.events.subscribe(res => {
      if (res instanceof NavigationEnd) this.translate.get("GENERAL.OK").subscribe(() => {
        const url = res.url.slice(0, res.url.indexOf('?')).split('/')[3];
        const id = parseInt(res.url.split('/')[2]);

        this.data = !id ? [
            {
              icon: 'account_tree',
              route: `/smartfiltration`,
              label: this.translate.instant('GENERAL.MACHINES'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            }
        ] :
          [

            {
              icon: 'account_tree',
              route: `/smartfiltration`,
              label: this.translate.instant('GENERAL.MACHINES'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'home',
              route: `/smartfiltration/${id}/overview`,
              label: this.translate.instant('SMARTFILTRATION.OVERVIEW.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'factory',
              route: `/smartfiltration/${id}/production-list`,
              label: this.translate.instant('SMARTFILTRATION.PRODUCTION.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'CIP',
              route: `/smartfiltration/${id}/cip-list`,
              label: this.translate.instant('SMARTFILTRATION.CIP.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'Consumption',
              route: `/smartfiltration/${id}/consumption`,
              label: this.translate.instant('SMARTFILTRATION.CONSUMPTION.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'Fluxtest',
              route: `/smartfiltration/${id}/flux-test`,
              label: this.translate.instant('SMARTFILTRATION.FLUX_TEST.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'Chemical',
              route: `/smartfiltration/${id}/chemical`,
              label: this.translate.instant('SMARTFILTRATION.CHEMICAL.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
            {
              icon: 'Select_check_box',
              route: `/smartfiltration/${id}/service`,
              label: this.translate.instant('SMARTFILTRATION.SERVICE.TITLE'),
              iconBaseUrl: `${environment.redirectUri}assets/icons/`
            },
          ]
      });
    })
    this.botItems = [{
      key: 'about',
      icon: 'c-info',
      label: 'UI-LIB.NAV-BAR.ABOUT',
      type: SidepanelTypes.FOOTER,
      ref: AboutPanelComponent,
      inputs: {
        copyright: 'GEA Group Services GmbH 2025',
        footers: [
          {
            key: 'imprint-header',
            header: 'UI-LIB.FOOTER.IMPRINT',
            content: [
              {
                key: 'imprint',
                icon: 'pdf',
                label: 'UI-LIB.FOOTER.IMPRINT',
                action: this.openImprint.bind(this),
              },
            ],
          },
          {
            key: 'privacy-header',
            header: 'UI-LIB.FOOTER.DATAPRIVACY',
            content: [
              {
                key: 'privacy',
                icon: 'pdf',
                label: 'UI-LIB.FOOTER.DATAPRIVACY',
                action: this.openDataprivacy.bind(this),
              },
            ],
          },
          {
            key: 'terms-header',
            header: 'UI-LIB.FOOTER.TERMS-AND-CONDITIONS',
            content: [
              {
                key: 'terms',
                icon: 'pdf',
                label: 'UI-LIB.FOOTER.TERMS-AND-CONDITIONS',
                action: this.openTermsAndConditions.bind(this),
              },
            ],
          },
          {
            key: 'cookie-settings',
            header: 'UI-LIB.FOOTER.COOKIE-SETTINGS',
            content: [
              {
                key: 'cookies',
                icon: 'pdf',
                label: 'UI-LIB.FOOTER.COOKIES',
                action: this.openEula.bind(this),
              },
            ],
          },
        ],
      } as AboutPanelInputs,
    },
    ] as SidePanel[];
  }

}
